export default __webpack_public_path__ + "static/media/log-out.61afe05e.svg";